var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Modal } from '../common/Modal';
import { List, ListItemSelect } from '@bootstraplabs/bsw-common-react';
export default function AddMemberModalUI(props) {
    // State
    var _a = useState(''), userId = _a[0], setUserId = _a[1];
    // Initialize state
    useEffect(function () {
        if (!props.users.some(function (user) { return user.id === userId; })) {
            setUserId((props.users[0] && props.users[0].id) || '');
        }
    }, [props.users, userId]);
    // Event handlers
    var handleConfirm = function () { return props.onConfirm(userId); };
    var handleCancel = function () { return props.onCancel(userId); };
    return (_jsx(Modal, __assign({ "data-test": "modal-add-member", title: "Add Member", open: props.open, onCancel: handleCancel, onConfirm: handleConfirm, disabled: !props.users.length }, { children: _jsx(List, { children: _jsx(ListItemSelect, { label: "Members", value: userId, onChange: setUserId, options: props.users }, void 0) }, void 0) }), void 0));
}
//# sourceMappingURL=AddMemberModalUI.js.map